import { Controller } from "stimulus"

export default class extends Controller {
  close () {
    fetch(this.element.getAttribute("data-url"))
  }
}
